import React from 'react';

import { FormattedMessage } from 'react-intl';

import messages from '../../../locale/messages';
import style from '../ScheduleForm/ScheduleForm.scss'; // eslint-disable-line css-modules/no-unused-class

const ExpressInterestFormError = () => (
  <div className={style.scheduleFormError}>
    <FormattedMessage {...messages.generalStringSomethingWentWrong} />
  </div>
);

export default ExpressInterestFormError;
